import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLike, meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {JoinOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/join-operator/geometry-join-operator-node"
import {GeometryJoinOperatorNode, joinOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute-set/join-operator/geometry-join-operator-node"

export type MeshGeometryJoinOperatorParameters = JoinOperatorParameters<
    MeshGeometryAttributeLikeNode,
    MeshGeometryAttributeSetLikeNode,
    MeshGeometryAttributeLikeNode,
    MeshGeometryAttributeSetLikeNode
>

const definition: TemplateNodeDefinition<MeshGeometryJoinOperatorParameters> = {
    nodeClass: "MeshGeometryJoinOperator",
    validation: {
        parameters: joinOperatorParametersSchema(
            meshGeometryAttributeLike,
            meshGeometryAttributeSetLike,
            meshGeometryAttributeLike,
            meshGeometryAttributeSetLike,
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryJoinOperator
    extends GeometryJoinOperatorNode<
        2,
        MeshGeometryAttributeLikeNode,
        MeshGeometryAttributeSetLikeNode,
        MeshGeometryAttributeLikeNode,
        MeshGeometryAttributeSetLikeNode
    >
    implements MeshGeometryAttributeSetLikeNode
{
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    protected override get outputIndexingDim(): 2 {
        return 2
    }
}
